export default __webpack_public_path__ + "static/media/logoAux.64fb8c3b.png";